import React, { useState, useEffect, useRef } from "react";
import EmptyPage from "../emptyPages";
import TrendingNow from "../recommendedForYou/recommendedcart";
import AddAddressDialogBox from "../myProfile/addAddressDialogBox";
import productImage from "../../assets/productImage.png";
import { shopid, getUserId, imagePrefix } from "../../utils/url";
import { HiTrash } from "react-icons/hi";
import { FaRegHeart } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaTag } from "react-icons/fa6";
import {
  fetchCart,
  removeFromCart,
  updateCartQuantity,
} from "../../../node_modules/shops-query/src/modules/cart/index.js";
import { addToWishlistController } from "../../../node_modules/shops-query/src/modules/wishlist/index.js";
import { fetchShippingCost } from "../../../node_modules/shops-query/src/modules/ShippingCost/index.js";
import { fetchCouponCode } from "../../../node_modules/shops-query/src/modules/CouponCode/index.js";
import {
  getGuestCart,
  removeFromGuestCart,
  updateGuestCartQuantity,
  clearGuestCart,
} from "../../utils/handleGuestCart";
import {
  fetchAddress,
  addAddress,
  mutateAddress,
} from "../../../node_modules/shops-query/src/modules/address/index.js";
import shopController from "../../../node_modules/shops-query/src/modules/shop/index.js";
import PaymentComponent from "../paymentComponent";
import { useToast } from "../toast";
import { useContext } from "react";
import LoginModalContext from "../../contexts/LoginModalContext";
import ConfirmationDialog from "../confirmationModal";
import HangerLoader from "../loading";

const Cart = () => {
  const [cart, setCart] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [dropdownVisibility, setDropdownVisibility] = useState({});
  const [deliveryCharge, setDeliveryCharge] = useState(null);
  const [couponDialog, setCouponDialog] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponDiscount, setCouponDiscount] = useState(null);
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [pincode, setPincode] = useState("");
  const [addresses, setdAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(1); // To track the address selected by the user
  const [addressSelected, setAddressSelected] = useState(false); // To track if a user has selected an address or not
  const [addressToShow, setAdressToShow] = useState(null);
  const [filteredAddresses, setFilteredAddresses] = useState([]);
  const [shopInfo, setShopInfo] = useState(null);
  const { showToast } = useToast();
  const { openLogin } = useContext(LoginModalContext);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);
  const dropdownRefs = useRef({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [editAddress, setEditAddress] = useState(null);
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [checkoutStage, setCheckoutStage] = useState(null); // null | 'ADDRESS' | 'PAYMENT'

  const userId = getUserId();

  useEffect(() => {
    const getCartData = async () => {
      try {
        setLoading(true);
        if (userId) {
          // User is logged in - fetch from server
          const shopData = await fetchCart(shopid, userId);
          setCart(shopData || []);
        } else {
          // User is not logged in - get from guest cart cookie
          const guestCart = getGuestCart();
          setCart(guestCart || []);
        }
      } catch (error) {
        console.log("An error occurred", error);
        // If error and no userId, try guest cart
        if (!userId) {
          const guestCart = getGuestCart();
          setCart(guestCart || []);
        }
      } finally {
        setLoading(false);
      }
    };
    getCartData();
  }, [userId]);

  // Listen for cart updates from other components
  useEffect(() => {
    const handleCartUpdate = () => {
      if (!userId) {
        const guestCart = getGuestCart();
        setCart(guestCart || []);
      }
    };

    window.addEventListener('cartUpdated', handleCartUpdate);
    return () => window.removeEventListener('cartUpdated', handleCartUpdate);
  }, [userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchShopDetails = async () => {
      try {
        const shopData = await shopController.fetchShops({ id: shopid });
        setShopInfo(shopData?.[0] || shopData);
      } catch (error) {
        console.log("Error Occured", error);
      }
    };
    fetchShopDetails();
  }, []);



  const fetchCouponHandler = async (shopid) => {
    if (!userId) {
      openLogin();
      return;
    }
    setCouponDialog(true);
    try {
      const couponCodeData = await fetchCouponCode(shopid);
      setCouponCode(couponCodeData?.[0]?.code);
      setCouponDiscount(couponCodeData?.[0]?.discount);
    } catch (error) {
      console.log("Coupon Error", error);
    }
  };

  // Note: handleAddressSelect currently unused; keep for future dialog integration

  const handleSelect = (itemId, value) => {
    setQuantities((prev) => ({
      ...prev,
      [itemId]: value,
    }));
    setDropdownVisibility((prev) => ({
      ...prev,
      [itemId]: false,
    }));
  };

  const calculateDiscountPercentage = (originalPrice, discountPrice) => {
    if (originalPrice <= 0) return 0;
    const percent = (discountPrice / originalPrice) * 100;
    if (percent > Math.floor(percent) + 0.5) {
      return Math.ceil(percent);
    } else if (percent < Math.floor(percent) + 0.4) {
      return Math.floor(percent);
    } else {
      return Math.round(percent);
    }
  };

  useEffect(() => {
    const getShippingCost = async (shopid) => {
      try {
        const shippingCost = await fetchShippingCost(shopid);
        if (shippingCost !== null) {
          setDeliveryCharge(shippingCost);
        }
      } catch (error) {
        console.log("Error while calculating shipping cost", error);
      }
    };
    getShippingCost(shopid);
  }, []);

  const removeFromCartHandler = async (productId) => {
    try {
      if (userId) {
        // User is logged in - remove from server
        await removeFromCart({ userId, shopId: shopid, productId });
        window.dispatchEvent(new Event('cartUpdated'));
      } else {
        // Guest user - update local guest cart
        removeFromGuestCart(productId);
      }
      setCart((prevCart) =>
        prevCart.filter((item) => item.productId !== productId)
      );
    } catch (error) {
      console.log("Error removing product from Cart", error);
    }
  };

  const movetoWishlistHandler = async (productId) => {
    try {
      if (!userId) {
        openLogin();
        return;
      }
      await removeFromCartHandler(productId);
      await addToWishlistController(productId, shopid, userId);
    } catch (error) {
      console.log("Error moving to wishlist ", error);
    }
  };

  const handleCartAction = async (
    productId,
    action,
    currentQuantity = 1,
    newQuantity = 1
  ) => {
    try {
      let updatedQuantity = currentQuantity;

      if (action === "increase") updatedQuantity++;
      else if (action === "decrease") updatedQuantity--;
      else if (action === "set") updatedQuantity = newQuantity;

      setQuantities((prev) => ({
        ...prev,
        [productId]: updatedQuantity,
      }));

      if (userId) {
        // User is logged in - update on server
        await updateCartQuantity({
          userId,
          productId,
          shopId: shopid,
          quantity: updatedQuantity,
        });
        window.dispatchEvent(new Event('cartUpdated'));
      } else {
        // Guest user - update local guest cart
        updateGuestCartQuantity(productId, updatedQuantity);
      }
    } catch (error) {
      console.log("An error occurred while updating the quantity", error);
    }
  };
  const handleOptionClick = (item, newQuantity) => {
    handleCartAction(item.productId, "set", item.quantity, newQuantity + 1);
    handleSelect(item.productId, newQuantity + 1);
  };

  const handleAddress = async () => {
    if (!userId) return; // Skip if not logged in
    try {
      const addressData = await fetchAddress({ userId: Number(userId) });
      if (addressData && addressData.length > 0) {
        setAddressSelected(true);
        setdAddresses(addressData);
        setAdressToShow(addressData[0]);
        setSelectedAddress(addressData[0]);
        setFilteredAddresses(addressData);
      } else {
        setAddressSelected(false);
        setdAddresses([]);
        setAdressToShow(null);
        setSelectedAddress(null);
        setFilteredAddresses([]);
      }
    } catch (error) {
      console.log("Error occured while showng address", error);
    }
  };

  const openAddressDialogBox = () => {
    if (!userId) {
      openLogin();
      return;
    }
    setAddressDialogOpen(true);
  };

  useEffect(() => {
    handleAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const handleCheckPincode = () => {
    if (!pincode.trim()) {
      setFilteredAddresses(addresses); // show all if empty
      return;
    }

    const matches = addresses.filter(
      (addr) => addr.pincode.toString().trim() === pincode.trim()
    );

    setFilteredAddresses(matches);
  };

  useEffect(() => {
    if (pincode.trim() === "") {
      setFilteredAddresses(addresses);
    }
  }, [pincode, addresses]);

  const handleDeleteAddress = async () => {
    try {
      if (!userId) {
        showToast({ message: "Please login to delete addresses", type: "warning" });
        return;
      }
      await mutateAddress({
        userId: Number(userId),
        addressId: addressToDelete,
        delete: true,
      });
      setdAddresses((prev) =>
        prev.filter((addr) => addr.id !== addressToDelete)
      );
      setDeleteConfirmation(false);
      setAddressToDelete(null);
    } catch (error) {
      console.log("Something went wrong while deleting ", error);
    }
  };

  const handleAddAddress = () => {
    if (!userId) {
      openLogin();
      return;
    }
    setShowAddAddressModal(!showAddAddressModal);
  };

  const saveAddressHandler = async (addressData, addressId = null) => {
    try {
      const payload = {
        ...addressData,
        name: addressData.firstName,
      };

      if (addressId) {
        // Update existing
        await mutateAddress({
          ...payload,
          userId: Number(userId),
          addressId,
          update: true,
        });

        showToast({ message: "Address updated successfully!" });
      } else {
        // Add new
        await addAddress(payload);
        showToast({ message: "Address added successfully!" });
      }

      // Refresh list
      const refreshed = await fetchAddress({ userId: Number(userId) });
      setdAddresses(refreshed);
      setFilteredAddresses(refreshed);

      if (refreshed && refreshed.length > 0) {
        setAddressSelected(true);
        // If we just added/updated, update the displayed address.
        // For a new address, it might be the last one, or we can just pick the first one or finding the one we just touched.
        // For simplicity, let's select the one that matches the payload or just the first/last one.
        // Usually, the backend returns the list. If we want to be precise we'd need the ID.
        // But simply setting the first one is a safe default if we assume the user wants *an* address selected.

        // Better logic: if there was no address selected, select the first one.
        // If an address was updated, we should probably make sure addressToShow reflects it.

        // Let's just default to the most recently added/updated one if possible, or just the first one if specific logic is hard.
        // IF we assume refreshed list is sorted or we just pick the first one:

        // If addressId was passed (update), find it.
        // If new, it might be at the end or start.

        // Let's just set the first address as active for now to ensure *some* address is shown, 
        // updating the UI state from "No Address" to "Address".

        // Actually, let's find the address that matches the one we just saved if possible, or just use the first/last.
        // For now, let's just use the first one to be consistent with handleAddress.
        // Or better:

        if (addressId) {
          const updated = refreshed.find(a => a.id === addressId);
          if (updated) {
            setAdressToShow(updated);
            setSelectedAddress(updated);
          }
        } else {
          // For new address, we might not know the ID immediately without response from addAddress.
          // But usually it's the last one? Or first?
          // Safest is to just set *an* address if none was selected, or update the current one.
          // Let's set the first one as default if we didn't have one, or just update the list.

          // If we want to auto-select the new address, we'd need to know which one it is.
          // Let's assume the user wants to use the new address.
          // Since we don't have the new ID easily, distinct from others, let's just pick the last item
          // assuming it appends, OR just the first one.
          // Actually, simplest fix: just call handleAddress logic again which selects the first one.

          // BUT, let's explicitly set it here to be instant.
          const latest = refreshed[refreshed.length - 1]; // Assume appended?
          // Or just use index 0.
          const target = refreshed[0];
          setAdressToShow(target);
          setSelectedAddress(target);
        }
      }

      // Close ALL modals properly
      setShowAddAddressModal(false);
      setAddressDialogOpen(false);
      setEditAddress(null);

    } catch (error) {
      console.log("Something went wrong while saving:", error);
      showToast({ message: "Failed to save address" });
    }
  };


  if (loading && userId) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <HangerLoader message="Fetching your cart..." size="large" />
      </div>
    );
  }

  if (cart.length === 0) {
    return (
      <div className="font-poppins px-3 sm:px-6 lg:px-16 w-full mx-auto overflow-hidden pb-20 sm:pb-10">
        <p className="mt-6 font-semibold text-[18px] sm:text-[20px] md:text-[24px] uppercase">
          MY SHOPPING BAG (0 ITEMS)
        </p>
        <EmptyPage
          className="font-poppins mt-6"
          message="Your bag is feeling a little light."
          subMessage="Let's fill it with something you'll love."
          buttonText="Shop Now"
          onButtonClick={() => navigate("/")}
        />
      </div>
    );
  }

  return (
    <div className="font-poppins px-3 sm:px-6 lg:px-16 w-full mx-auto pb-20 sm:pb-10">
      {/* Header */}
      <p className="mt-6 font-semibold text-[18px] sm:text-[20px] md:text-[24px] uppercase">
        MY SHOPPING BAG ({cart.length} ITEM{cart.length !== 1 ? "S" : ""})
      </p>

      {cart.length === 0 ? (
        <EmptyPage
          className="font-poppins mt-6"
          message="Your bag is feeling a little light."
          subMessage="Let's fill it with something you'll love."
          buttonText="Shop Now"
          onButtonClick={() => navigate("/")}
        />
      ) : (
        <>
          {/* MAIN CONTAINER */}
          <div className="flex flex-col lg:flex-row gap-6 mt-4 w-full">
            {/* LEFT SIDE — Address + Products */}
            <div className="w-full lg:w-[65%]">
              {/* Address Box */}
              <div className="w-full rounded-lg border border-gray-200 px-4 py-3 flex flex-col sm:flex-row sm:items-start sm:justify-between mt-6 gap-2">
                {/* Left side — Deliver to and address */}
                <div className="flex flex-col">
                  <div className="flex flex-wrap items-center gap-2">
                    <p className="font-normal text-[14px] sm:text-[16px]">
                      Deliver to:
                    </p>

                    {addressSelected ? (
                      <p className="font-semibold text-[16px] sm:text-[18px] leading-[100%] capitalize">
                        {addressToShow?.name} {addressToShow?.pincode}
                      </p>
                    ) : (
                      <p className="text-[#C4C4C4] px-2 py-1 rounded">
                        No Address selected
                      </p>
                    )}
                  </div>

                  {addressSelected && (
                    <p className="font-semibold text-[14px] sm:text-[16px] leading-[100%] capitalize mt-3">
                      {addressToShow?.street} {addressToShow?.city}
                    </p>
                  )}
                </div>

                {/* Right side — Add Address button */}
                <p
                  className="font-semibold text-[14px] sm:text-[16px] underline text-primary-default cursor-pointer mt-3 sm:mt-0 uppercase"
                  onClick={openAddressDialogBox}
                >
                  {addressSelected ? "CHANGE ADDRESS" : "ADD NEW ADDRESS"}
                </p>
              </div>

              {/* Cart Items */}
              <div className="pr-2 mt-4">
                {cart.map((item, index) => {
                  const productId = item?.productId ?? index;
                  const image = item?.featureImage;
                  const discountPrice = item?.Discount || 0;
                  const prize = item?.prize || 0;
                  const finalPrice = prize - discountPrice;
                  const discountPercentage = calculateDiscountPercentage(
                    prize,
                    discountPrice
                  );
                  const isOutOfStock =
                    item.noStock !== null && item.noStock <= 0;

                  const currentQuantity =
                    quantities[item.productId] || item?.quantity || 1;

                  return (
                    <div
                      key={productId}
                      className="flex flex-row border-b border-gray-200 py-4 sm:py-5 w-full mt-4 gap-3 sm:gap-4"
                    >
                      {/* Product Image */}
                      <div className="flex-shrink-0">
                        <img
                          src={image ? imagePrefix + image : productImage}
                          alt={item?.name || "Product"}
                          className="h-[150px] w-[110px] sm:h-[170px] sm:w-[130px] md:h-[210px] md:w-[150px] object-cover rounded-md"
                        />
                      </div>

                      {/* Product Details */}
                      <div className="flex flex-col flex-1 justify-between min-w-0">
                        <div>
                          <p className="font-semibold text-[16px] sm:text-[18px] capitalize truncate">
                            {item?.name}
                          </p>

                          <div className="flex items-center flex-wrap gap-2 md:gap-3 mt-1 sm:mt-2">
                            <p className="font-semibold text-[16px] sm:text-[18px] text-black">
                              ₹{Math.round(finalPrice)}
                            </p>
                            {discountPrice > 0 && (
                              <p className="text-[14px] sm:text-[16px] line-through text-gray-400">
                                ₹{Math.round(prize)}
                              </p>
                            )}

                            {discountPrice > 0 && (
                              <p className="font-semibold text-[14px] sm:text-[16px] text-primary-default">
                                {discountPercentage}% OFF
                              </p>
                            )}
                          </div>

                          {/* Size & Quantity - Side by Side on Mobile */}
                          <div className="flex flex-row items-center gap-2 sm:gap-3 mt-3">
                            <div className="flex-1 sm:w-[143px] sm:flex-none h-[40px] sm:h-[43px] border border-gray-200 rounded-md flex items-center px-2 sm:px-3">
                              <p className="text-[12px] sm:text-[14px] whitespace-nowrap">
                                Size:{" "}
                                <span className="font-semibold capitalize">
                                  {item?.size || "L"}
                                </span>
                              </p>
                            </div>

                            {/* Unifying quantity dropdown for both mobile and PC */}

                            {/* Unified custom dropdown */}
                            <div className="relative block w-[120px] sm:w-[23%] h-[40px] sm:h-[43px]">
                              <div
                                className="w-full h-full border border-gray-200 rounded-md flex items-center justify-between px-3 cursor-pointer select-none bg-white"
                                onClick={() =>
                                  setDropdownVisibility((prev) => ({
                                    ...prev,
                                    [item.productId]: !prev[item.productId],
                                  }))
                                }
                              >
                                <button className="flex items-center gap-1 text-[13px] sm:text-[16px]">
                                  Quantity:
                                  <span className="font-semibold flex items-center gap-1">
                                    {currentQuantity}
                                    <IoIosArrowDown />
                                  </span>
                                </button>
                              </div>

                              {dropdownVisibility[item.productId] &&
                                !isOutOfStock && (
                                  <div
                                    ref={(el) =>
                                    (dropdownRefs.current[item.productId] =
                                      el)
                                    }
                                    className="absolute mt-1 top-full left-0 w-full bg-white border border-gray-300 rounded shadow-lg max-h-40 overflow-y-auto z-10"
                                  >
                                    {[...Array(10).keys()].map((i) => (
                                      <div
                                        key={i}
                                        className="px-3 py-2 hover:bg-[#FF8466] hover:text-white cursor-pointer text-[13px] sm:text-sm transition-colors"
                                        onClick={() =>
                                          handleOptionClick(item, i)
                                        }
                                      >
                                        {i + 1}
                                      </div>
                                    ))}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>

                        {/* Wishlist / Remove - Bottom Row */}
                        <div className="flex flex-row items-center gap-4 mt-4 sm:mt-0 text-[#101011] text-[13px] sm:text-[16px]">
                          <button
                            className="flex items-center gap-1 sm:gap-2 hover:text-primary-default whitespace-nowrap"
                            onClick={() => movetoWishlistHandler(productId)}
                          >
                            <FaRegHeart size={18} className="sm:w-5 sm:h-5" />
                            <span>Move to wishlist</span>
                          </button>

                          <button
                            className="flex items-center gap-1 sm:gap-2 hover:text-red-600 whitespace-nowrap"
                            onClick={() => removeFromCartHandler(productId)}
                          >
                            <HiTrash size={18} className="sm:w-5 sm:h-5" />
                            <span>Remove</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Add More from Wishlist */}
              <div
                className="w-full h-auto rounded-md border border-gray-200 px-4 py-4 flex items-center gap-2 mt-6 cursor-pointer hover:bg-gray-50 transition"
                onClick={() => {
                  if (!userId) {
                    openLogin();
                    return;
                  }
                  navigate("/wishlist");
                }}
              >
                <FaRegHeart />
                <span className="text-[14px] sm:text-[16px]">
                  Add more from wishlist
                </span>
              </div>
            </div>

            {/* RIGHT SIDE — Coupons & Price card */}
            <div className="w-full lg:w-[35%] md:mt-[1.6%] lg:sticky lg:top-[20px] h-fit">
              <div className="w-full rounded-lg border border-gray-200 p-4 sm:p-5">
                <div className="flex flex-col">
                  {/* Coupons Header */}
                  <p className="font-poppins font-semibold text-[18px] sm:text-[20px] leading-[100%] uppercase mb-4">
                    Coupons
                  </p>

                  {/* Apply Coupons Row */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                      <FaTag className="w-[18px] sm:w-[22px] h-[18px] sm:h-[22px] text-[#000]" />
                      <p className="font-poppins font-normal text-[14px] sm:text-[16px] ml-3">
                        Apply Coupons
                      </p>
                    </div>
                    <p
                      className="font-poppins font-semibold text-[14px] sm:text-[16px] uppercase underline text-primary-default cursor-pointer"
                      onClick={() => fetchCouponHandler(shopid)}
                    >
                      Apply
                    </p>
                  </div>

                  <div className="border-b border-gray-200 mb-4"></div>

                  {/* Price Details */}
                  <p className="font-semibold text-[18px] sm:text-[20px] uppercase mb-3">
                    Price Details ({cart.length}{" "}
                    {cart.length > 1 ? "ITEMS" : "ITEM"})
                  </p>

                  <div className="flex flex-col gap-3 text-[14px] sm:text-[15px]">
                    <div className="flex justify-between">
                      <p>Total MRP</p>
                      <p>
                        ₹
                        {Math.round(
                          cart.reduce((total, item) => {
                            const quantity =
                              quantities[item.productId] || item?.quantity || 1;
                            const price = item?.prize || 0;
                            return total + price * quantity;
                          }, 0)
                        )}
                      </p>
                    </div>

                    <div className="flex justify-between">
                      <p>Discount on MRP</p>
                      <p>
                        ₹
                        {Math.round(
                          cart.reduce(
                            (total, item) => total + (item.Discount || 0),
                            0
                          )
                        )}
                      </p>
                    </div>

                    <div className="flex justify-between">
                      <p>Coupon Discount</p>
                      <p>₹{couponApplied ? couponDiscount || 0 : 0}</p>
                    </div>

                    <div className="flex justify-between">
                      <p>Delivery Charges</p>
                      <p>₹{Number(deliveryCharge) || 0}</p>
                    </div>
                  </div>

                  <div className="border-b border-gray-200 my-4"></div>

                  <div className="flex justify-between font-semibold text-[16px] sm:text-[18px]">
                    <p>Total Amount</p>
                    <p>
                      ₹
                      {(() => {
                        const totalMRP = cart.reduce((total, item) => {
                          const quantity =
                            quantities[item.productId] || item?.quantity || 1;
                          const price = item?.prize || 0;
                          return total + price * quantity;
                        }, 0);

                        const discountOnMRP = cart.reduce((total, item) => {
                          const quantity =
                            quantities[item.productId] || item?.quantity || 1;
                          const discount = item?.Discount || 0;
                          return total + discount * quantity;
                        }, 0);

                        const delivery = Number(deliveryCharge) || 0;

                        const totalAmount =
                          totalMRP -
                          discountOnMRP -
                          (couponDiscount || 0) +
                          delivery;

                        return Math.round(totalAmount);
                      })()}
                    </p>
                  </div>

                  {/* Button for tablet+ (visible on sm+) */}
                  <div className="mt-4 hidden sm:block">
                    <button
                      className="w-full bg-primary-default text-white text-center uppercase font-semibold py-3 rounded-md text-[14px] sm:text-[16px]"
                      onClick={() => {
                        if (!userId) {
                          openLogin();
                          return;
                        }
                        if (cart.length === 0) {
                          showToast({ message: "Cart is empty", type: "warning" });
                          return;
                        }
                        setCheckoutStage("ADDRESS");
                        // Ensure an address is pre-selected if available
                        if (!addressSelected && addresses.length > 0) {
                           setAdressToShow(addresses[0]);
                           setSelectedAddress(addresses[0]);
                           setAddressSelected(true);
                        }
                      }}
                    >
                      PLACE ORDER
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 sm:mt-12 ">
            <TrendingNow
              showCategories={false}
              excludeIds={cart.map(item => item.productId)}
            />
          </div>
          {/* MOBILE STICKY BAR — shows on small screens only */}
          <div className="fixed bottom-0 left-0 right-0 sm:hidden bg-white border-t p-3 z-50">
              <div className="flex items-center justify-between gap-3">
                <div>
                  <p className="text-xs text-gray-500">Total</p>
                  <p className="font-semibold text-[16px]">
                    ₹
                    {Math.round(
                      cart.reduce((total, item) => {
                        const quantity =
                          quantities[item.productId] || item?.quantity || 1;
                        const price = item?.prize || 0;
                        return total + price * quantity;
                      }, 0) -
                      cart.reduce((total, item) => {
                        const quantity =
                          quantities[item.productId] || item?.quantity || 1;
                        const discount = item?.Discount || 0;
                        return total + discount * quantity;
                      }, 0) -
                      (couponDiscount || 0) +
                      (Number(deliveryCharge) || 0)
                    )}
                  </p>
                </div>

                <button
                  className="bg-primary-default text-white py-3 px-4 rounded-md text-sm font-semibold"
                  onClick={() => {
                    if (!userId) {
                      openLogin();
                      return;
                    }
                    if (cart.length === 0) return;
                    setCheckoutStage("ADDRESS");
                     if (!addressSelected && addresses.length > 0) {
                           setAdressToShow(addresses[0]);
                           setSelectedAddress(addresses[0]);
                           setAddressSelected(true);
                     }
                  }}
                >
                  PLACE ORDER
                </button>
              </div>
          </div>
        </>
      )}

      {/* Coupon Code Dialog Box */}
      {couponDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center px-4 z-50">
          <div className="relative bg-white rounded-2xl shadow-lg w-full max-w-[320px] p-6 text-center">
            {/* Close Icon */}
            <button
              onClick={() => setCouponDialog(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <IoMdClose size={22} />
            </button>

            <h2 className="text-lg sm:text-xl font-semibold mb-4">
              Coupon Code
            </h2>
            <input
              type="text"
              value={couponCode}
              readOnly
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-700 bg-gray-100 cursor-not-allowed mb-4"
            />
            <button
              onClick={() => {
                setCouponApplied(true);
                setCouponDialog(false);
              }}
              className="px-4 py-2 bg-primary-default text-white rounded-lg w-full"
            >
              Apply Coupon Code
            </button>
          </div>
        </div>
      )}

      {/* Address Dialog */}
      {addressDialogOpen && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-end sm:items-center justify-center p-0 sm:px-4">
          <div
            className="
      bg-white w-full sm:max-w-[480px] 
      rounded-t-xl sm:rounded-xl 
      max-h-[85vh] flex flex-col
      relative animate-slideUp
    "
          >
            {/* Sticky Header */}
            <div className="flex justify-between items-center p-5 sm:p-6 border-b border-gray-100 sticky top-0 bg-white z-10 rounded-t-xl sm:rounded-t-xl">
              <h2 className="text-base sm:text-lg font-semibold uppercase">
                Change Address
              </h2>
              <button
                onClick={() => setAddressDialogOpen(false)}
                className="text-2xl text-gray-700"
              >
                <IoMdClose />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="p-5 sm:p-6 overflow-y-auto">

              {/* Pincode Input */}
              {/* <div className="md:flex mb-5 hidden border border-gray-300 rounded-md overflow-hidden">
              <input
                type="text"
                placeholder="Enter Pincode"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                className="flex-1 px-3 py-2 text-sm outline-none"
              />
              <button
                onClick={handleCheckPincode}
                className="px-4 py-2 text-[#FF4C24] font-semibold text-sm"
              >
                CHECK
              </button>
            </div> */}

              {/* Saved Addresses Title */}
              <h3 className="font-semibold mb-3 text-sm sm:text-base">
                Saved Addresses
              </h3>

              {/* Address List */}
              {filteredAddresses.length > 0 ? (
                filteredAddresses.map((addr, index) => (
                  <div
                    key={addr.id || index}
                    className="border border-gray-300 rounded-md p-3 mb-4 flex gap-3"
                  >
                    <input
                      type="radio"
                      name="address"
                      checked={selectedAddress?.id === addr.id}
                      onChange={() => {
                        setSelectedAddress(addr);
                        setAdressToShow(addr);
                      }}
                      className="mt-1 w-4 h-4"
                    />

                    <div className="flex-1">
                      {/* Tag */}
                      <span className="bg-gray-200 text-gray-700 text-[10px] px-2 py-1 rounded-sm uppercase">
                        {addr.type || "Home"}
                      </span>

                      {/* Name & Pincode */}
                      <p className="font-semibold mt-1 text-sm">
                        {addr.name},{" "}
                        <span className="font-bold">{addr?.pincode}</span>
                      </p>

                      {/* Full Address */}
                      <p className="text-gray-600 text-xs leading-relaxed">
                        {addr.street}, {addr.city}, {addr.state}, {addr.country}
                      </p>

                      {/* Buttons */}
                      <div className="flex gap-4 mt-3">
                        <button
                          onClick={() => {
                            setEditAddress(addr);
                            setShowAddAddressModal(true);
                          }}
                          className="text-xs border border-black px-3 py-1 rounded-sm"
                        >
                          EDIT
                        </button>

                        <button
                          onClick={() => {
                            setDeleteConfirmation(true);
                            setAddressToDelete(addr.id);
                          }}
                          className="text-xs border border-black px-3 py-1 rounded-sm"
                        >
                          DELETE
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-gray-500 text-sm">No saved addresses found.</p>
              )}

              {/* Add Address Button */}
              <div
                onClick={() => handleAddAddress()}
                className="border border-gray-300 rounded-md p-3 text-[#FF4C24] font-semibold text-center mt-2 cursor-pointer underline"
              >
                + ADD NEW ADDRESS
              </div>
            </div>
          </div>
        </div>
      )}

      {showAddAddressModal && (
        <AddAddressDialogBox
          isOpen={showAddAddressModal}
          onClose={() => setShowAddAddressModal(false)}
          onSave={saveAddressHandler}
          initialData={editAddress}
          userId={userId}
        />
      )}

      <ConfirmationDialog
        isOpen={deleteConfirmation}
        title="Are You Sure You Want To Delete the Address?"
        confirmLabel="DELETE"
        cancelLabel="CANCEL"
        onConfirm={handleDeleteAddress}
        onCancel={() => setDeleteConfirmation(false)}
      />

       {/* Step 1: Address Selection Modal */}
      {checkoutStage === "ADDRESS" && !showAddAddressModal && (
        <div className="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center p-4 max-h-[100vh]">
          <div className="bg-white w-full max-w-[500px] rounded-xl flex flex-col max-h-[90vh]">
            <div className="flex justify-between items-center p-5 border-b border-gray-100">
              <h2 className="text-lg font-semibold uppercase">Select Delivery Address</h2>
              <button onClick={() => setCheckoutStage(null)} className="text-2xl text-gray-700">
                <IoMdClose />
              </button>
            </div>
            <div className="p-5 overflow-y-auto">
               {addresses && addresses.length > 0 ? (
                 addresses.map((addr, index) => (
                   <div
                     key={addr.id || index}
                     className={`border rounded-md p-3 mb-4 cursor-pointer transition-colors ${selectedAddress?.id === addr.id ? 'border-[#FF4C24] bg-orange-50' : 'border-gray-300'}`}
                     onClick={() => {
                        setSelectedAddress(addr);
                        setAdressToShow(addr);
                        setAddressSelected(true);
                     }}
                   >
                     <div className="flex gap-3">
                       <div className="mt-1">
                          <div className={`w-4 h-4 rounded-full border border-gray-400 flex items-center justify-center ${selectedAddress?.id === addr.id ? 'border-[#FF4C24]' : ''}`}>
                             {selectedAddress?.id === addr.id && <div className="w-2 h-2 rounded-full bg-[#FF4C24]" />}
                          </div>
                       </div>
                       <div className="flex-1">
                          <span className="bg-gray-200 text-gray-700 text-[10px] px-2 py-1 rounded-sm uppercase">
                             {addr.type || "Home"}
                           </span>
                           <p className="font-semibold mt-1 text-sm">{addr.name}, <span className="font-bold">{addr?.pincode}</span></p>
                           <p className="text-gray-600 text-xs leading-relaxed mt-1">
                             {addr.street}, {addr.city}, {addr.state}, {addr.country}
                           </p>
                       </div>
                     </div>
                   </div>
                 ))
               ) : (
                 <div className="text-center py-10 text-gray-500">
                    No addresses found. Please add one.
                 </div>
               )}
               
               <button 
                 onClick={handleAddAddress}
                 className="w-full border border-[#FF4C24] text-[#FF4C24] font-semibold py-3 rounded-md uppercase mb-4"
               >
                 + Add New Address
               </button>
            </div>
            
            <div className="p-5 border-t border-gray-100 bg-gray-50 rounded-b-xl">
               <button 
                 className="w-full bg-[#FF4C24] text-white font-semibold py-3 rounded-md uppercase disabled:opacity-50"
                 disabled={!selectedAddress}
                 onClick={() => {
                    if(selectedAddress) {
                       setCheckoutStage("PAYMENT");
                    } else {
                       showToast({message: "Please select an address", type: "warning"});
                    }
                 }}
               >
                 Proceed to Payment
               </button>
            </div>
          </div>
        </div>
      )}

      {/* Step 2: Payment Method Modal */}
       {checkoutStage === "PAYMENT" && (
        <div className="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-[500px] rounded-xl p-5 max-h-[90vh] overflow-y-auto">
             <PaymentComponent
                cartAmount={(() => {
                  const totalMRP = cart.reduce((total, item) => {
                    const quantity = quantities[item.productId] || item?.quantity || 1;
                    const price = item?.prize || 0;
                    return total + price * quantity;
                  }, 0);
                  const discountOnMRP = cart.reduce(
                    (total, item) => total + (item.Discount || 0),
                    0
                  );
                  const delivery = Number(deliveryCharge) || 0;
                  return Math.round(totalMRP - discountOnMRP - (couponDiscount || 0) + delivery);
                })()}
                orderAddress={selectedAddress}
                shopId={shopid}
                userId={userId}
                shopPhone={shopInfo?.phone}
                cartItems={cart}
                siteConfig={{
                    razorpayKey: shopInfo?.siteConfigurations?.razorpayKey,
                    razorpaySecretKey: shopInfo?.siteConfigurations?.razorpaySecretKey,
                    phonePeKey: shopInfo?.siteConfigurations?.phonePeKey,
                    name: shopInfo?.name,
                }}
                showToast={showToast}
                onOrderSuccess={(msg) => {
                  showToast({ message: "Order Placed Successfully! " + msg });
                  if (!userId) clearGuestCart();
                  window.dispatchEvent(new Event("cartUpdated"));
                  setCheckoutStage(null);
                  setTimeout(() => navigate("/"), 1500);
                }}
                onOrderFailure={(err) => {
                   showToast({
                    message: typeof err === "string" ? err : err?.message || "Failed to place order",
                    type: "error"
                  });
                }}
                onClose={() => setCheckoutStage(null)}
              />
          </div>
        </div>
      )}

    </div>
  );
};
export default Cart;
